import { getPictogrammeEquipeById } from '@/constants/pictogrammesEquipe';
import { cn } from '@/lib/utils';

interface EquipeIconProps {
  pictogramme: string;
  couleur: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showBackground?: boolean;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

const containerSizeClasses = {
  sm: 'w-6 h-6 rounded',
  md: 'w-8 h-8 rounded-lg',
  lg: 'w-10 h-10 rounded-xl',
};

export function EquipeIcon({
  pictogramme,
  couleur,
  size = 'md',
  className,
  showBackground = true,
}: EquipeIconProps) {
  const picto = getPictogrammeEquipeById(pictogramme);

  if (!picto) {
    return (
      <div className={cn(
        containerSizeClasses[size],
        "bg-muted flex items-center justify-center",
        className
      )}>
        <span className="text-muted-foreground">?</span>
      </div>
    );
  }

  const Icon = picto.icon;

  if (showBackground) {
    return (
      <div
        className={cn(
          containerSizeClasses[size],
          "flex items-center justify-center shrink-0",
          className
        )}
        style={{ backgroundColor: `${couleur}20` }}
      >
        <Icon
          className={sizeClasses[size]}
          style={{ color: couleur }}
        />
      </div>
    );
  }

  return (
    <Icon
      className={cn(sizeClasses[size], "shrink-0", className)}
      style={{ color: couleur }}
    />
  );
}
